import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Keychallengesanimal() {
  return (
    <section className="key-challenges-animal p-100">
      <Container>
        <div className="key-challenge-box">
          <div className="img mb-4 mb-md-5 text-center">
            <StaticImage
              src="../../../images/case-studies/animal-debt/Overcoming.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1028}
              height={353}
            />
          </div>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={10}
              xxl={10}
              className="m-auto text-center"
            >
              <h2>
                <span style={{ color: "#007F6E" }}>Overcoming the Odds</span>
              </h2>
              <h3 style={{ color: "#202020", marginBottom: "10px" }}>
                The Key Challenges TekRevol Tackled in Developing Animal Debt
                Disaster
              </h3>
            </Col>
          </Row>
          <Row>
            <h4
              style={{ color: "#202020", marginBottom: "10px" }}
              className="text-center"
            >
              Key Pain Points
            </h4>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 mb-lg-0">
              <div className="key-pain-box">
                <div className="icon">
                  <StaticImage
                    src="../../../images/case-studies/animal-debt/key-point-1.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={97}
                    height={90}
                  />
                </div>
                <h5>Real Physics Simulation in a Genre That Rarely Uses It</h5>
                <p>
                  Animal Debt Disaster introduced a physics-based approach where
                  every tool interaction follows real-world physics, adding
                  depth and unpredictability. This design requires players to
                  think creatively, making each puzzle unique and challenging.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 mb-lg-0">
              <div className="key-pain-box">
                <div className="icon">
                  <StaticImage
                    src="../../../images/case-studies/animal-debt/key-point-2.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={97}
                    height={90}
                  />
                </div>
                <h5>
                  Every puzzle is designed to be solved in more than one way.
                </h5>
                <p>
                  The game’s puzzles allow for multiple solutions — from
                  precise, strategic actions to chaotic, accidental successes.
                  This approach ensures replayability, as players find new ways
                  to solve puzzles and share the funniest moments.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
              <div className="key-pain-box">
                <div className="icon">
                  <StaticImage
                    src="../../../images/case-studies/animal-debt/key-point-3.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={97}
                    height={90}
                  />
                </div>
                <h5>Balancing humor with engaging gameplay</h5>
                <p>
                  Creating a game that’s both absurdly funny and compelling to
                  play was a challenge. The humor had to be natural and engaging
                  without detracting from the gameplay experience, striking the
                  perfect balance between fun and functionality.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Keychallengesanimal;
